export const LS_FACTOR_SETTINGS = 'factorSettings'
